import { Link } from "wouter";
import { Megaphone, Store, Tag, Calendar, ArrowRight } from "lucide-react";

const FREE = [
  { href: "/submit-business", icon: Store, title: "Add a business listing", desc: "Get your business in the Ayrshire Hub directory - free." },
  { href: "/submit-deal", icon: Tag, title: "Post a deal", desc: "Share an offer with the whole of Ayrshire - free." },
  { href: "/submit-event", icon: Calendar, title: "Post an event", desc: "List your event in the What's On feed - free." },
];

export default function Advertise() {
  return (
    <div className="max-w-3xl mx-auto p-4">
      <div className="text-center mb-6">
        <Megaphone className="mx-auto text-primary" size={40} />
        <h1 className="text-3xl font-bold mt-2">Advertise on Ayrshire Hub</h1>
        <p className="text-gray-600 mt-1">Reach thousands of locals across Ayrshire.</p>
      </div>

      {/* Paid: in-feed advert */}
      <Link href="/create-ad">
        <a className="block rounded-2xl bg-primary text-white p-5 mb-6 hover:bg-primary/90 transition">
          <div className="flex items-center justify-between">
            <div>
              <div className="text-lg font-bold">Run an in-app advert</div>
              <div className="text-white/80 text-sm mt-1">Your image, headline and a button - shown right in the food, deals, events and news feeds. Pay by card, live after a quick review.</div>
            </div>
            <ArrowRight size={22} />
          </div>
        </a>
      </Link>

      <h2 className="text-sm font-semibold text-gray-500 uppercase tracking-wide mb-2">Free ways to get seen</h2>
      <div className="grid gap-3">
        {FREE.map(f => (
          <Link key={f.href} href={f.href}>
            <a className="flex items-center gap-3 border rounded-xl p-4 hover:bg-gray-50 transition">
              <f.icon className="text-primary shrink-0" size={22} />
              <div className="flex-1">
                <div className="font-semibold">{f.title}</div>
                <div className="text-sm text-gray-500">{f.desc}</div>
              </div>
              <ArrowRight size={18} className="text-gray-400" />
            </a>
          </Link>
        ))}
      </div>

      <div className="text-center mt-6">
        <Link href="/my-adverts"><a className="text-primary text-sm font-medium">View my adverts & stats →</a></Link>
      </div>
    </div>
  );
}
